export class ParametersContainer {
    static clear() {
        ParametersContainer.parameters = {};
    }
    static set(parameters) {
        Object.keys(parameters).forEach((parameterKey) => {
            ParametersContainer.parameters[parameterKey] = parameters[parameterKey];
        });
    }
    static get(id) {
        return ParametersContainer.parameters[id] || null;
    }
}
ParametersContainer.parameters = {};
//# sourceMappingURL=ParametersContainer.js.map